import React, { useEffect, useState } from 'react';
import { SimplePageHeader } from '../../../components';
import { useInternationalization } from '../../i18n';
import { reseter, useViewport, valueAdapter } from '../../../utils';
import PageResultDesktop from './page-result-desktop';
import PageResultMobile from './page-result-mobile';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'query-string';
import { useDispatch, useSelector } from 'react-redux';
import { setQueryString, getQueryResults, setCollection } from '../slice';
import { setSelectedApproaches, setSelectedIssues, setSelectedOrganizationTypes } from '../slice';
import { fetchSystemList } from '../../system/slice';

const PageResult = ({customHeader, customNav, filterOptions}) => {
  const history = useHistory()
  const location = useLocation()
  const { isDesktop } = useViewport()
  const { translate } = useInternationalization()
  const pageTitle = translate('SEARCH', 'search_results')
  const { language, status } = useSelector(state => state.system)
  const dispatch = useDispatch()
  const query = qs.parse(location.search)
  const lastQueryString = useSelector(state => state.search.queryString)
  const lastCollection = useSelector(state => state.search.collection)
  const [lastParams, setLastParams] = useState('')

  const {
    approachesById,
    issuesById,
    organizationTypesById
  } = useSelector(state => state.system);

  const {
    selectedApproaches,
    selectedIssues,
    selectedOrganizationTypes,
  } = useSelector(state => state.search);

  const config = {
    approach: {
      param: "typeApproach",
      setter: setSelectedApproaches,
      map: approachesById,
      selectedValues: selectedApproaches,
    },
    issue: {
      param: "typeIssue",
      setter: setSelectedIssues,
      map: issuesById,
      selectedValues: selectedIssues,
    },
    organizationType: {
      param: "typeOrganisasi",
      setter: setSelectedOrganizationTypes,
      map: organizationTypesById,
      selectedValues: selectedOrganizationTypes,
    },
  };

  function prepareOptions(){
    const queryString = location.search
    const currentParams = new URLSearchParams(queryString)
    const collection = currentParams.get('collection')
    const query = qs.parse(queryString)

    // Decide if need to fetch results counts again or not
    let needHelper = false
    const currentParams2 = new URLSearchParams(queryString)
    currentParams2.delete('collection')
    if (currentParams2.has('limit')) currentParams2.delete('limit')
    if (currentParams2.has('offset')) currentParams2.delete('offset')
    const currentParamsWithoutCollection = currentParams2.toString()
    if(lastParams !== currentParamsWithoutCollection){
      needHelper = true
      setLastParams(currentParamsWithoutCollection)
    }

    const options = {...query, apiKey: collection, needHelper}
    dispatch(getQueryResults(options))
  }

  function catchNewQuery(){
    const queryString = location.search
    const currentParams = new URLSearchParams(queryString)

    // Check params, then update store if needed
    const availableParams = Object.keys(config)
    availableParams.forEach((paramKey) => {
      const currentIds = currentParams.getAll(config[paramKey].param);

      if(currentIds.length > 0){
        const currentObjects = currentIds.map((id) => {
          return {
            label: config[paramKey].map[id]?.name[language.name],
            value: parseInt(id),
          };
        });

        const storeIsNotUpdated = config[paramKey].selectedValues.length !== currentObjects.length
        if (storeIsNotUpdated) {
          dispatch(config[paramKey].setter(currentObjects));
        }
      } else {
        dispatch(config[paramKey].setter([]));
      }
    });

    // Set collection to store, get data from API
    if(currentParams.has('collection')){
      const collection = currentParams.get('collection')
      const isRequestingNewCollection = lastCollection !== collection

      if(isRequestingNewCollection){
        dispatch(setCollection(collection)).then(prepareOptions)
      } else {
        prepareOptions()
      }
    }
  }

  // Query Catcher
  useEffect(() => {
    console.log({status})
    if(status === 'idle'){
      dispatch(fetchSystemList())
    } else if (status === 'succeeded'){
      console.log({location, lastQueryString})
      const isNewQuery = location.search !== lastQueryString
      if(isNewQuery){
        dispatch(setQueryString(location.search))
        catchNewQuery()
      }
    }

    // eslint-disable-next-line
  }, [location.search, status])

  const handleSort = (newSorter) => {
    const { key, value } = newSorter

    if (valueAdapter[value]) {
      const cloned = reseter(query)
      const finalKey = key === 'title' ? 'sort_by_title' : key

      const newQuery = {
        ...cloned,
        [finalKey]: valueAdapter[value]
      }

      history.push({
        pathname: location.pathname,
        search: qs.stringify(newQuery)
      })
    }
  };

  return (
    <>
      {customHeader ? customHeader : <SimplePageHeader title={pageTitle} />}
      {
        isDesktop ? (
          <PageResultDesktop onSort={handleSort} customNav={customNav} filterOptions={filterOptions}/>
        ) : (
          <PageResultMobile onSort={handleSort} customNav={customNav} filterOptions={filterOptions}/>
        )
      }
    </>
  )
}

export default PageResult
